import Swal from "sweetalert2";

const ConfirmDialog = ({ title, text, icon = "warning", confirmText = "Yes", cancelText = "No" }) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
  });
};

export default ConfirmDialog;
